import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { CardContainer, CardWithModal, TitleAndEditButton } from 'shared-components';

import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';

import BorderRefusals from './borderRefusals';
import { IBorderRefusal } from '../../../../../types';

import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useCustomNavigate } from '../../../../../hooks/useCustomNavigate';

const VisaPrepFormAddHistoryPage6 = (props: any) => {
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE2_6));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  const { navigateTo } = useCustomNavigate();

  const onEdit = () => navigateTo(`${props.params.offerId}/history/step-2`);

  // state props from store
  const defaultArr = useMemo(() => {
    return [];
  }, []);
  const borderRefusals =
    useSelector(({ student }: ApplicationState) => student.visa.borderRefusals, shallowEqual) || defaultArr;

  // constants
  const currentStep = 6;
  const steps = 8;

  // component state
  const [complete, setComplete] = useState(false);
  const [borderRefusalsState, setBorderRefusalsState] = useState<IBorderRefusal[]>([]);
  const [showModal, setShowModal] = useState<boolean[]>([]);

  useEffect(() => {
    setBorderRefusalsState([
      ...borderRefusals,
      {
        airport: '',
        reason: '',
        reference: '',
        refusalDate: '',
      },
    ]);
    setShowModal([...borderRefusals.map(_ => false), false]);
  }, [borderRefusals]);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      borderRefusals,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, borderRefusals]);

  const toggleModal = (index: number) => {
    setShowModal(showModal.map((value, i) => (i === index ? !value : value)));
  };

  const deleteRefusal = (index: number): void => {
    onChange(VQ.BORDER_REFUSALS, [...borderRefusals.slice(0, index), ...borderRefusals.slice(index + 1)]);
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Additional History'}
    >
      <TitleAndEditButton
        title="You indicated that you have previously received a UK border refusal"
        onClick={onEdit}
      />

      <CardContainer title={`Number of border refusals`}>
        {borderRefusalsState.map((refusal: IBorderRefusal, index: number) => (
          <CardWithModal
            key={index}
            id={`border-refusals-${index}`}
            index={index}
            modalTitle={'Add Border Refusal'}
            cardItems={[
              {
                label: 'Date of refusal',
                value: refusal.refusalDate,
              },
              {
                label: 'Port or airport',
                value: refusal.airport,
              },
              {
                label: 'Reason',
                value: refusal.reason,
              },
              {
                label: 'Reference number',
                value: refusal.reference,
              },
            ]}
            onRemove={deleteRefusal}
            addButtonLabel={`Add Border Refusal`}
            addAnotherButtonLabel={`I have another Border Refusal to add`}
            hasAddMoreButton={
              refusal.airport === '' && refusal.reason === '' && refusal.reference === '' && refusal.refusalDate === ''
            }
            showModal={showModal[index]}
            toggleModal={toggleModal}
          >
            <BorderRefusals
              index={index}
              airport={refusal.airport}
              reason={refusal.reason}
              reference={refusal.reference}
              refusalDate={refusal.refusalDate}
              onSaveAndClose={(refusal: IBorderRefusal) => {
                const refusals = [...borderRefusals];
                refusals[index] = {
                  ...refusal,
                };
                onChange(VQ.BORDER_REFUSALS, refusals);
                toggleModal(index);
              }}
            />
          </CardWithModal>
        ))}
      </CardContainer>
    </QuestionPage>
  );
};
export default VisaPrepFormAddHistoryPage6;
